import {
  resourceState,
  resourceMutations,
  resourceGetters,
  resourceActions,
} from '@/store/utils/resource';
import { TAGS } from '@/store/entities/schema_types';
import { contactRequestTagsClient as client } from '@/api/clients';
import mapKeysToSnakeCase from '@/utils/map-keys-to-snake-case';

export default {
  namespaced: true,
  state: resourceState(),
  mutations: resourceMutations,
  getters: resourceGetters(TAGS),
  actions: {
    ...resourceActions,
    async load(ctx, { id, query = {} }) {
      try {
        const response = await client.list(id, query);

        const { data, meta } = response;

        const tagIds = await ctx.dispatch(
          'entities/persistEntities',
          { type: TAGS, data },
          { root: true }
        );

        ctx.commit({
          type: 'setIdsByParent',
          parentId: id,
          ids: tagIds,
        });

        return Promise.resolve({ tagIds, meta });
      } catch (error) {
        const { response } = error;

        return Promise.reject(response);
      }
    },
    async update(ctx, { id, formData }) {
      try {
        const response = await client.update(id, mapKeysToSnakeCase(formData));

        const tagIds = await ctx.dispatch(
          'entities/persistEntities',
          { type: TAGS, data: response.data },
          { root: true }
        );

        ctx.commit({
          type: 'setIdsByParent',
          parentId: id,
          ids: tagIds,
        });

        return Promise.resolve(tagIds);
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
